import { render, staticRenderFns } from "./TypographyWhatNotToDoSection.vue?vue&type=template&id=9e96db3e"
import script from "./TypographyWhatNotToDoSection.vue?vue&type=script&lang=ts"
export * from "./TypographyWhatNotToDoSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyWhatNotToDoSection.vue?vue&type=style&index=0&id=9e96db3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports